RivalIQ.apps.Insights.module('collections', function (collections, App, Backbone, Marionette, $, _) {

    'use strict';

    const Collection = Backbone.Collection.mixin({
        mixins: {
            FetchByPostMixin: RivalIQ.utils.FetchByPostMixin
        },

        url: function () {
            return `/api/accounts/${RivalIQ.state.account.get('id')}/insights`;
        }
    });

    _.reduce(RivalIQ.enums.insightsObjectType, function (memo, objectType) {
        return _.set(memo, _.upperFirst(objectType), Collection.extend({
            objectType: objectType
        }));
    }, collections);

    const parameterDefaults = function () {
        const keysAndDefaults = {
            searchTerm: undefined,
            companyId: undefined,
            channel: undefined,
            timePeriod: RivalIQ.state.view.get('timePeriod'),
            timezone: undefined,
            orderBy: undefined,
            sortOrder: undefined,
            limit: 0
        };

        return keysAndDefaults;
    };

    /**
     * Normalize the given search params.
     * @param params
     * @returns {*}
     */
    collections.normalizeInsightsParams = function (params) {

        params = _.clone(params);

        if (params.timePeriod) {
            params.timePeriod = _.clone(params.timePeriod);
            RivalIQ.utils.timePeriod.rehydrate(params.timePeriod);

            params.startDate = params.timePeriod.mainPeriodStart;
            params.endDate = params.timePeriod.mainPeriodEnd;
            params.compareStartDate = params.timePeriod.comparePeriodStart;
            params.compareEndDate = params.timePeriod.comparePeriodEnd;
        }

        if (!params.timezone) {
            params.timezone = RivalIQ.utils.timezone.getClientTimezoneString();
        }

        _.defaults(params, parameterDefaults());

        // normalize the searchTerm
        params.searchTerm = (_.isString(params.searchTerm) ? params.searchTerm.trim() : '');

        return params;
    };

});
